import React, {useEffect, useState} from "react";
import {Col, Row} from "react-bootstrap";
import ApiService from "../../services/ApiService";
import DateTimeUtils from "../../services/DateTimeUtils";

const CardCourse = ({bookedCourses}) => {

    const [courseData, setCourseData] = useState();
    const [participant, setParticipant] = useState();
    const [level, setLevel] = useState();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [course, participantData] = await Promise.all([
                    ApiService.getCourseById(bookedCourses.courseId),
                    ApiService.getParticipantById(bookedCourses.participantId),
                ]);

                let livello = await ApiService.getLevelById(course.levelCourseId)

                setLevel(livello)
                setCourseData(course);
                setParticipant(participantData);
            } catch (error) {
                // Handle errors if needed
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

        return (
            <Row className="card card-product g-0 mb-3">
                <Col xs={12} md={4} lg={12} xl={4}>
                    <Row className={'g-0'}>
                        <Col xs={12} sm={6} md={12} lg={6} xl={12}>
                            <div className={'fw-bold py-1 px-2 p-md-2'}>
                                Corso
                            </div>
                        </Col>
                        {courseData && <Col xs={12} sm={6} md={12} lg={6} xl={12} className={'h-100'}>
                            <div className={'py-1 px-2 p-md-2 card-detail'}>
                                <p className={'mb-0'}>{courseData.title}</p>
                                <p className={'mb-0'}>{level.level}</p>
                                <p className={'mb-0'}>{"Durata corso: " + courseData.noOfLessons + " lezioni"}</p>
                                <p className={'mb-0'}>{"Inizio corso: " + DateTimeUtils.formatCourseStart(courseData.start)}</p>
                            </div>
                        </Col>}
                    </Row>
                </Col>
                <Col xs={12} md={4} lg={12} xl={4}>
                    <Row className={'g-0'}>
                        <Col xs={12} sm={6} md={12} lg={6} xl={12}>
                            <div className={'fw-bold py-1 px-2 p-md-2'}>
                                Partecipante
                            </div>
                        </Col>
                        {participant && <Col xs={12} sm={6} md={12} lg={6} xl={12} className={'h-100'}>
                            <div className={'py-1 px-2 p-md-2 card-detail'}>
                                <p className={'mb-0'}>{participant.firstName} {participant.lastName}</p>
                                <p className={'mb-0'}>{DateTimeUtils.getParticipantDob(participant)}</p>
                                <p className={'mb-0'}>{participant.currentLevel}</p>
                            </div>
                        </Col>}
                    </Row>
                </Col>
                <Col xs={12} md={4} lg={12} xl={4}>
                    <Row className={'g-0'}>
                        <Col xs={12} sm={6} md={12} lg={6} xl={12}>
                            <div className={'fw-bold py-1 px-2 p-md-2'}>
                                Stato
                            </div>
                        </Col>
                        <Col xs={12} sm={6} md={12} lg={6} xl={12} className={'h-100'}>
                            <div className={'py-1 px-2 p-md-2 card-detail border-bottom-0'}>
                                <p className={'mb-0'}>{bookedCourses.status}</p>
                            </div>
                        </Col>
                    </Row>
                </Col>
            </Row>
        )
}
export default CardCourse;